<div class="idle-warning-backdrop" *ngIf="visible" data-testid="idle-warning-backdrop">
  <div class="idle-warning-dialog"
       role="alertdialog"
       aria-modal="true"
       aria-labelledby="idle-warning-title"
       aria-describedby="idle-warning-countdown"
       cdkTrapFocus
       [cdkTrapFocusAutoCapture]="true"
       data-testid="idle-warning-dialog">
    <svg aria-hidden="true" class="idle-warning-icon" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <circle cx="12" cy="12" r="10"></circle>
      <polyline points="12 6 12 12 16 14"></polyline>
    </svg>
    <h2 id="idle-warning-title">Still there?</h2>
    <p>You've been inactive for a while. For your security, you'll be signed out soon.</p>
    <p id="idle-warning-countdown" class="idle-warning-countdown" aria-live="polite" data-testid="idle-warning-countdown">
      Signing out in {{ secondsLeft }} second{{ secondsLeft === 1 ? '' : 's' }}&hellip;
    </p>
    <button type="button" class="idle-warning-stay-btn" (click)="stayActive()" data-testid="idle-warning-stay-btn">
      Stay signed in
    </button>
  </div>
</div>
